export const INITIAL_STATE = {};

const FIVE_MINUTES = 5 * 60;

export const DEFAULT_MAX_AGE = FIVE_MINUTES;
